const initialState = {
  businessName: '',
  logoUrl: '',
  timezone: '',
  language: '',
  webPropertyUrl: '',
  devPropertyUrl: '',
  showContactsEvents: false,
  showOnlyFromBranch: false,
  portalFooterDescription: '',
  smtp: '',
  port: '',
  companyId: null,
  apiKey: null,
  showInternalInfoInApi: false,
  showNotAvailableInApi: false,
  legalCheckRequired: false,
  publishWithoutLegalCheck: false,
  legalCheckBaseText: '',
  watermarkSettings: {
    hasSettings: false,
    watermarkEnabled: false,
    watermarkLogoUrl: '',
    opacity: 60,
    size: 'small',
    position: 'center',
    type: 'double',
    marginPx: 12,
    preview: 'landscape',
    newLogoFile: null,
  },
  modals: {
    editionOpen: false,
    confirmOpen: false,
  },
  loading: {
    logoUpload: false,
    watermarkLogoUpload: false,
    applyWatermarkSettings: false,
    regenerateApiKey: false,
  },
  timezonesList: [],
  initialWatermarkSettings: null,
};

export default initialState;
